// extracted by mini-css-extract-plugin
export default {"recipe":"recipe_recipe__WXSZp","image":"recipe_image__4txKP"};